import { render, staticRenderFns } from "./lawDetail.vue?vue&type=template&id=77d45e77"
import script from "./lawDetail.vue?vue&type=script&lang=js"
export * from "./lawDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports